
export const getUniqueTagsFromVideos = (videos, initialFocusRef) => {
    const allTags = videos?.flatMap(content => content.tagsDetails || []) ?? [];
    const tagsById = new Map(allTags.map(tag => [tag._id, tag]));
    const uniqueTags = [...tagsById.values()];
    if (uniqueTags.length > 0 && initialFocusRef.current.length === 0) {
        initialFocusRef.current = uniqueTags;
    }
    return uniqueTags;
}